<template>
  <div class="query-header">
    <el-row
      :gutter="20"
    >
      <el-col
        :lg="4"
        :md="12"
        :sm="24"
        :xs="24"
        class="el-col-el"
      >
        <el-select
          v-model="strategyId"
          placeholder="选择策略"
          style="width: 100%"
          class=""
          clearable
          filterable
          @change="toQuery"
        >
          <el-option
            v-for="(item,index) in strategyList"
            :key="index"
            :label="item.strategyName"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-col>
      <el-col
        :lg="4"
        :md="12"
        :sm="24"
        :xs="24"
        class="el-col-el"
      >      
      <el-select  style="width: 100%" v-model="rules" filterable  clearable @change="toQuery" placeholder="推送规则">
        <el-option
          v-for="item in ruleslist"
          :key="item.id"
          :label="item.ruleName"
          :value="item.id">
        </el-option>
        </el-select>
      </el-col>

      <el-col
        :lg="4"
        :md="12"
        :sm="24"
        :xs="24"
        class="el-col-el"
      >
        <el-select
          style="width: 100%"
          v-model="channelType"
          placeholder="类型"
          clearable
          @change="toQuery"
        >
          <el-option
            v-for="(item,key) in channelList"
            :key="key"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-col>
      <el-col
        :lg="4"
        :md="12"
        :sm="24"
        :xs="24"
        class="el-col-el"
      >
        <el-select
          v-model="status"
          placeholder="推送状态"
          style="width: 100%"
          class=""
          clearable
          @change="toQuery"
        >
          <el-option
            v-for="(item,index) in statusList"
            :key="index"
            :label="item.label"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-col>
      <el-col
        :lg="8"
        :md="12"
        :sm="24"
        :xs="24"
        class="el-col-el"
      >
        <el-date-picker
          v-if="!realMobile"
          style="width: 100%"
          class="mar-bot10 header-item"
          v-model="pickerTime"
          type="daterange"
          align="left"
          value-format="yyyy-MM-dd HH:mm:ss"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        <!--@change="toQuery"-->
        </el-date-picker>
        <select-date-duration
          class="header-item"
          v-model="pickerTime"
        ></select-date-duration>
      </el-col>
      <span style="display: inline-block;width: 10px"></span>
      <vs-button
        type="info"
        class="search-btn btn box-item"
        @click="searchHandle"
      >查询</vs-button>


      
    </el-row>
  </div>
</template>

<script>
import { queryTypeList,rulesList } from "@/api/wx/strategyActicle";
import  { mapGetters } from 'vuex';
export default {
  name: "queryHeader",
  data() {
    return {
      strategyId: '',
      strategyList: [],
      channelType: '',
      channelList : [
        {label: '微信公众号',value: 1},
        {label: 'Telegram',value: 2},
        {label: 'Lark应用',value: 3},
        {label: '企业微信',value: 4},
        {label: '个人微信',value: 5},
        {label: 'Lark机器人',value: 6},
        {label: '钉钉',value: 7},
        {label: 'MT4',value: 8},
        {label: 'Line',value: 9},
        {label: 'QQ',value: 10},
      ],
      ruleslist: [],
      rules: '',
      status: '',
      statusList:[
        {id: 1,label: '成功'},
        {id: 0,label: '失败'}
      ],
      pickerTime: []
    }
  },
  computed: {
    ...mapGetters(['userInfo','realMobile']),
  },
  created(){
   this.getTypeList();
   this.getRuleslist();
  },
  methods: {
    toQuery(){
      this.$emit('toQuery');
    },
    getTypeList(){
      queryTypeList({
      'page': 1,
      'limit': 1000,
    }).then((res) => {
        this.strategyList = res.page.list;
      })
    },
    getRuleslist(){
      rulesList({
      'page': 1,
      'limit': 1000,
    }).then((res) => {
        this.ruleslist = res.list.list;
      })
    },
    
    searchHandle(){
      this.toQuery();
    }
  },
}
</script>

<style lang="scss" scoped>
.query-header {
  .header-sub-item {
    width: 100%;
  }
  .box-item {
    margin-top: 10px;
  }
}
</style>
